/**
 * Endpoints comunitarios — métricas y rankings agregados de la plataforma.
 */
import { api } from "./client";

export interface CommunitySummary {
  users_active: number;
  users_new_7d: number;
  avg_album_pct: number;
  total_owned: number;
  total_dups: number;
  trades_completed: number;
  trades_last_7d: number;
  listings_active: number;
  catalog_size: number;
}

export interface CollectorRow {
  user: {
    id: number;
    name: string;
    handle: string | null;
    city: string | null;
    country: string;
    avatar_color: string;
    initials: string;
    verified: boolean;
    stars_avg: number;
    trades_completed: number;
    level: number;
  };
  album_pct: number;
  owned: number;
  dups_total: number;
}

export interface CountryRow {
  country: string;
  users_count: number;
  avg_album_pct: number;
  total_dups: number;
}

export interface RecentTradeRow {
  id: number;
  from_user: CollectorRow["user"];
  to_user: CollectorRow["user"];
  items_count: number;
  completed_at: string;
}

export const fetchCommunitySummary = () => api<CommunitySummary>("/community/summary");
export const fetchTopCollectors = (limit = 10) => api<CollectorRow[]>(`/community/top-collectors?limit=${limit}`);
export const fetchMostTrades = (limit = 10) => api<CollectorRow[]>(`/community/most-trades?limit=${limit}`);
export const fetchBiggestTraders = (limit = 10) => api<CollectorRow[]>(`/community/biggest-traders?limit=${limit}`);
export const fetchByCountry = () => api<CountryRow[]>("/community/by-country");
export const fetchRecentTrades = (limit = 10) => api<RecentTradeRow[]>(`/community/recent-trades?limit=${limit}`);
